module.exports = __webpack_public_path__ + "static/media/logo.c827f7a2.png";